import {
  CollectionActions,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { _transformProjectFeed } from '../project-feed';
import { ProjectFeedFailingContestsCollection } from './project-feed-failing-contests.types';

export function projectFeedFailingContestsReducer(
  state = {},
  action: CollectionActions<ProjectFeedFailingContestsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'projectFeedFailingContests') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<ProjectFeedFailingContestsCollection>(
          state,
          transformIntoDocuments(result, _transformProjectFeed),
          order,
          ref,
        );
      }
      return state;
    default:
      return state;
  }
}
